<template>
    <div id="index">
        <div class="visible-xs min_index">
            <!-- 头部 -->
            <MinHeader :searchText="searchText" ref="header" @searchFun="searchFun"></MinHeader>
            <!-- 导航 -->
            <div class="head_top flex_center">
                <div class="head_li flex_center " :class="{'selected':head_index == 1}" @click="head_index = 1">发现</div>
            </div>
            <div class="list_center" v-if="list_arr.length>0">
                <MListLi :list_arr="list_arr"  ref="listLi" @detailsFun="detailsFun"></MListLi>
            </div>
            <div class="complete list_center" v-else-if="is_request">
                暂无数据 
            </div>
            <div class="complete list_center" v-else>
                加载中
            </div>
            <!-- 提示注册弹窗 -->
            <LoginPrompt @promptFun="promptFun" ref="prompt"></LoginPrompt>
            <!-- 尾部 -->
            <MinFooter :headIndex="4"></MinFooter>
        </div>
    </div>
</template>

<script>
    import MinHeader from "@/components/m_assembly/MinHeader.vue"; //头部模块
    import MinFooter from "@/components/m_assembly/MinFooter.vue"; //尾部模块
    import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
    import MListLi from '@/components/assembly/m_listLi.vue';//列表数据模块

    import "@/assets/js/swiper.animate1.0.3.min.js";
    import "@/assets/css/animate.min.css";
    import "@/assets/css/video-js.min.css";

    export default {
        name: "index",
        data() {
            return {
                head_index: 1,//1发现 2推荐 3关注 4热门 
                is_pc: true, //是否是pc端打开
                user: {},//用户信息
                page: 1,
                list_arr: [],

                searchText: '',//搜索内容
                is_request:false,
            };
        },
        computed: {
            MembershipType: function () {
                return this.MembershipGrade(this.user.plus);
            }
        },
        components: {
            MinHeader,
            MinFooter,
            LoginPrompt,
            MListLi
        },
        watch: {
            head_index: function (eve) {
                this.page = 1;
                this.getList();
            },
        },
        methods: {
            searchFun(text) {
                this.searchText = text;
                this.page = 1;
                this.getList()
            },
            detailsFun(id) {//查看详情
                this.$router.push({ path: '/m_column_details', query: { id: id, } });
            },
            promptFun() {//提示弹窗回调
                this.$router.replace("/m_registered");
            },
            getUser() {
                let that = this;
                this.REFRESH_USER();
                that.user = that.USER();
                that.getList();
            },
            getList() {//获取列表数据
                let that = this;
                this.is_request = false;
                if (this.page == 1) {
                    this.list_arr = [];
                }
                this.$post('news_recomm', {
                    type: this.head_index,
                    member_id: this.USER().id,
                    limit: 10,
                    keyword: this.searchText,
                    page: this.page,
                }).then(res => {
                    let arr = [];
                    that.is_request = true;
                    if (that.head_index == 2) {
                        let data = res.data.data.data;
                        let recomm = res.data.recomm.data;
                        let indexT = 0;
                        data.forEach((liem, index) => {
                            if ((indexT / 2) % 1 === 0 && recomm[indexT]) {
                                arr.push(recomm[indexT])
                                indexT++;
                            }
                            arr.push(liem)
                        })
                    } else {
                        arr = res.data.data;
                    }
                    that.list_arr = that.list_arr.concat(arr);
                    that.$nextTick(()=>{
            that.$refs.listLi.videoFun();
          })
                })
            },
        },
        mounted() {
            if (this.$route.query.searchText) {
                this.searchText = this.$route.query.searchText;
                this.$refs.header.headerFun(this.searchText);
            }
            document.title = '麻醉眼界';
            this.getShare();
            this.getUser();
            if (this._isMobile()) {

            } else {
                // alert("pc端");
                this.$router.replace("/");
            }
            let that = this;
            // $(window).scroll(function () {
            //     var scrollTop = $(this).scrollTop();
            //     var scrollHeight = $(document).height();
            //     var windowHeight = $(this).height();
            //     if (scrollTop + windowHeight + 2 >= scrollHeight) {
            //         that.page++;
            //         that.getList();
            //     }
            // });
        }
    };
</script>

<style scoped>
    html,
    body {
        max-width: 100vw;
    }

    #index {
        padding-top: 0;
    }

    header.header {
        box-shadow: 0 !important;
    }

    .visible-xs {
        width: 100vw;
        overflow: hidden;
        padding-top: 0rem !important;
    }

    /* 导航 */
    .head_top {
        position: fixed;
        top: 50px;
        left: 0;
        right: 0;
        padding: 0 5.5rem;
        background: #fff;
        box-shadow: 0 5px 9px rgba(71, 71, 71, 0.11);
        z-index: 998;
    }

    .head_top .head_li {
        height: 3.8rem;
        position: relative;
        font-size: 1.4rem;
        color: #999;
        border-bottom: .15rem solid #fff;
    }

    .head_top .head_li.selected {
        color: #333;
        font-weight: bold;
        border-color: #F04C61;
    }

    .list_center {
        padding-top: 9rem;
        padding-bottom: 4rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_found.vue